export default __webpack_public_path__ + "static/media/credit-card.7a8538c1.png";